import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { Link } from 'react-router-dom';
import { ReadVaraDto } from '@/api.types';
import { readVara } from './vara.service';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function VarasIndexPage() {
  const { setActions } = useBreadcrumbActions();

  const [registros, setRegistros] = useState<[ReadVaraDto[], number]>();
  const tableState = useDataTableState('ordem');

  const handleBuscar = () => {
    readVara({
      skip: (tableState.currentPage - 1) * tableState.pageSize,
      take: tableState.pageSize,
      orderBy: "ASC",
      orderField: "ordem",
      comAtuacao: true,
      comDefensorias: true
    })
      .then((result) => {
        setRegistros(result);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  }

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Varas_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadVaraDto>[] = [
    { key: "ordem", header: "Ordem" },
    { key: "nome", header: "Vara" },
    { key: "atuacao.nome", header: "Atuação" },
    {
      key: "defensorias", header: "Defensorias",
      render: (row) => {
        return (<>{row.defensorias?.length}</>)
      }
    },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Varas_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];


  return (
    <div className="row">
      <div className="col-12">
        <h3>Varas / Centrais</h3>
        <span className="blockquote-footer pb-4 text-end">
          Varas/Centrais de atuções das defensorias.
        </span>
      </div>
      <hr className="pb-4" />

      {registros &&
        <DataTable
          columns={colunas}
          data={registros[0]}
          initialSortKey='nome'
          onChange={handleBuscar}
          serverSide={true}
          states={tableState}
          totalRecords={registros[1]}
        />
      }

    </div>
  );
}
